<template>
  <div
    :class="'vertical-box ' + component_class"
    :style="{ border: '6px solid ' + color }"
  >
    <div class="commercial-div">
      <div class="card-header">
        <div
          class="fullname title-div"
          :style="{ color: color }"
          :title="item.nome + ' ' + item.cognome"
        >
          {{ getFullName() }}
        </div>
        <div class="bu-top title-div" :style="{ color: color }">
          {{ item.bu }}
        </div>
        <div class="initials rounded-div" :style="{ color: color }">
          {{ item.nome[0] + item.cognome[0] }}
        </div>
        <div class="bu title-div" :style="{ color: color }">
          {{ item.bu }}
        </div>
      </div>
      <div class="card-body">
        <div class="inner-card-body">
          <div v-if="item.ruolo" class="roleDivDefault">
            <img src="@/assets/info.svg" />
            <span :title="item.ruolo">{{ role }}</span>
          </div>
          <div v-if="item.ruolo" class="roleDivTruncate">
            <img src="@/assets/info.svg" />
            <span :title="item.ruolo">{{ roleTruncate }}</span>
          </div>
          <div v-if="item.email" class="emailDiv">
            <img src="@/assets/email.svg" />
            <span :title="item.email">{{ email }}</span>
          </div>
          <div v-if="item.telefono">
            <img src="@/assets/phone.svg" />
            <span :title="item.telefono">{{ phone }}</span>
          </div>
          <div v-if="item.cellulare">
            <img src="@/assets/mobile.svg" />
            <span :title="item.cellulare">{{ mobile }}</span>
          </div>
        </div>
      </div>
      <div class="button-back-div">
        <v-btn class="generic-button button-back" @click="back()">
          {{ $t("Misc.back") }}
        </v-btn>
      </div>
    </div>
    <div class="nocommercial-div">
      <div class="img-container">
        <div class="img-div">
          <img v-if="img_name" :src="require(`../assets/${img_name}.png`)" />
        </div>
        <div class="title-div" :style="{ color: color }">
          <span>{{ title }}</span>
        </div>
      </div>
      <div class="description-div">
        <span>{{ $t("Profile.NoCommercial") }}</span>
      </div>
    </div>

    <inputForm
      :showTerm="showTerm"
      :isProfile="isProfile"
      :email="item.email"
      :division="division"
      :isInQuotations="isInQuotations"
    ></inputForm>

    <div
      :class="isMobile ? 'vertical-align-right-20' : 'vertical-align-right-20'"
    >
      <v-btn class="generic-button button-request" @click="contact()">
        {{ getBtnName() }}
      </v-btn>
    </div>
  </div>
</template>
<style>
.vertical-box {
  position: relative;
  border-radius: 40px;
  box-shadow: 11px 13px 14px #6f767ab3;
  font: normal normal bold 20px/24px Lato;
  color: #707070;
  background-color: #ffffff;
  height: 100%;
}

.vertical-box .card-header .bu-top {
  margin-bottom: 10px;
  display: none;
}

.profile-main .vertical-box.full-commercial .card-header .bu-top {
  display: none;
}

.profile-main .vertical-box.full-commercial .card-header .bu {
  display: block;
}

.vertical-box .card-header {
  text-align: center;
  position: relative;
}

.vertical-box.nocommercial .title-div {
  width: 100%;
  font: normal normal bold 18px/22px Lato;
}

.vertical-box.three-commercial,
.vertical-box.two-commercial {
  margin-bottom: 16px;
}

.vertical-box.three-commercial .card-body,
.vertical-box.two-commercial .card-body {
  display: none;
}

.vertical-box .card-body {
  font: normal normal bold 15px/18px Roboto;
  letter-spacing: -0.3px;
  color: #707070;
}

.vertical-box .card-body img {
  width: 30px;
}

.custom-vertical-boxes-container .vertical-box.two-commercial {
  height: calc((100% - 16px) / 2);
}

.custom-vertical-boxes-container .vertical-box.three-commercial {
  height: calc((100% - 16px - 16px) / 3);
}

.custom-vertical-boxes-container .vertical-box:last-child {
  margin-bottom: 0;
}

.vertical-box.nocommercial {
  text-align: center;
}

.vertical-box .card-body span,
.vertical-box .card-body img {
  vertical-align: middle;
}

.vertical-box .card-body span {
  padding-left: 10px;
}

.vertical-box.full-commercial .bu {
  padding-top: 10px;
}

/* .vertical-box.full-commercial .bu-top {
  padding-top: 10px;
  padding-bottom: 10px;
} */

.vertical-box.two-commercial .card-header {
  padding-left: 140px;
}

.vertical-box.three-commercial .card-header {
  padding-left: 30px;
}

.vertical-box.full-commercial .card-header .fullname,
.vertical-box.three-commercial .card-header .fullname {
  padding-top: 12px;
  padding-bottom: 8px;
}

.vertical-box.two-commercial .card-header .fullname {
  padding-top: 38px;
  padding-bottom: 8px;
}

.vertical-box.two-commercial .card-header .initials {
  position: absolute;
  left: 12px;
  top: 12px;
}

.vertical-box.two-commercial .card-header,
.vertical-box.three-commercial .card-header {
  text-align: left;
}

.vertical-box.nocommercial .description-div {
  padding: 50px 16px 0 16px;
}

.vertical-box.two-commercial .info-div,
.vertical-box.three-commercial .info-div {
  display: none;
}

.vertical-box .info-div.col .col {
  padding: 12px 30px 12px 30px !important;
}

.vertical-box .info-div.col .col span {
  margin-left: 10px;
}

.vertical-box.three-commercial .data-div .col,
.vertical-box.two-commercial .data-div .col {
  padding: 0;
}

.vertical-box.two-commercial .data-div .col {
  padding-top: 10px;
}

.vertical-box.two-commercial .data-div .btn-col,
.vertical-box.three-commercial .data-div .btn-col {
  padding-top: 20px;
}

.vertical-box.two-commercial .data-div .btn-col {
  display: none;
}

.vertical-box.two-commercial .btn-two-col {
  display: inline;
  text-align: center;
  padding-top: 40px;
}

.vertical-box.full-commercial .btn-two-col {
  display: inline;
  text-align: center;
  padding-top: 40px;
}

.vertical-box.nocommercial .commercial-div {
  display: none;
}

.vertical-box.two-commercial .commercial-div,
.vertical-box.three-commercial .commercial-div,
.vertical-box.full-commercial .commercial-div {
  display: block;
}

.vertical-box.two-commercial .nocommercial-div,
.vertical-box.three-commercial .nocommercial-div,
.vertical-box.full-commercial .nocommercial-div,
.vertical-box.one-commercial .nocommercial-div {
  display: none;
}

.vertical-box.nocommercial .nocommercial-div {
  display: block;
}

.profile-main .vertical-box.two-commercial .commercial-div .rounded-div,
.profile-main .vertical-box.full-commercial .commercial-div .rounded-div {
  border: 6px solid;
  height: 111px;
  width: 111px;
  border-radius: 111px;
  margin: auto;
  text-align: center;
  line-height: 100px !important;
  font: normal normal bold 41px/48px Roboto;
  letter-spacing: 0px;
  background-color: #6f767a80;
}
.profile-main .vertical-box.three-commercial .commercial-div .rounded-div {
  display: none;
}

.vertical-box .title-div {
  text-transform: uppercase;
}

.vertical-box.three-commercial .commercial-div,
.vertical-box.two-commercial .commercial-div {
  position: relative;
}

.vertical-box.three-commercial .card-body,
.vertical-box.two-commercial .card-body,
.vertical-box.one-commercial .card-body {
  line-height: 60px !important;
  position: relative;
  height: 100%;
}

.vertical-box.three-commercial .card-body .inner-card-body,
.vertical-box.two-commercial .card-body .inner-card-body,
.vertical-box.one-commercial .card-body .inner-card-body {
  position: relative;
  width: 380px;
  top: 50%;
  transform: translateY(-50%);
}

.show-request-container .vertical-box.three-commercial .card-body {
  display: inline;
}

.card-header .bu.title-div {
  font: normal normal bold 18px/22px Lato;
}

@media (min-width: 600px) {
  .vertical-box.full-commercial button {
    bottom: 40px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .vertical-box.three-commercial .card-header .initials {
    position: absolute;
    left: 12px;
    top: 12px;
  }

  .vertical-box.nocommercial .img-container img {
    /* width: 180px; */
    position: relative;
    margin-top: 30px;
  }

  .vertical-box.two-commercial .btn-div button,
  .vertical-box.nocommercial button {
    bottom: 20px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .vertical-box.nocommercial button {
    bottom: 40px;
  }

  .vertical-box.nocommercial .title-div {
    /* padding-bottom: 40px; */
    position: absolute;
    top: 165px;
  }

  .quotations-main .vertical-box.two-commercial,
  .quotations-main .vertical-box.three-commercial {
    display: grid;
    width: 100%;
  }
}

@media (max-width: 600px) {
  .quotations-main .vertical-box.three-commercial,
  .quotations-main .vertical-box.two-commercial {
    margin-bottom: 0px;
  }

  .vertical-box.full-commercial .bu-top {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .vertical-box.three-commercial,
  .vertical-box.two-commercial {
    border-radius: 20px;
    display: flex;
    border-width: 4px !important;
  }

  .custom-vertical-boxes-container .vertical-box.full-commercial {
    height: 400px !important;
  }

  .vertical-box .card-header {
    padding-left: 126px;
    text-align: left;
    position: relative;
    height: 100%;
  }

  .vertical-box.two-commercial .card-header .initials,
  .vertical-box.three-commercial .card-header .initials {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
  }

  .vertical-box.three-commercial button,
  .vertical-box.two-commercial button {
    position: absolute;
    right: 14px !important;
    bottom: 14px !important;
  }

  .vertical-box .info-div {
    display: none;
  }

  .vertical-box.nocommercial img {
    width: 65px;
    margin-top: 20px;
  }

  .vertical-box.nocommercial {
    height: 120px;
    border-radius: 20px;
    display: flex;
    border-width: 4px !important;
  }

  .vertical-box.nocommercial .description-div {
    display: none;
  }

  .vertical-box.nocommercial button {
    margin-right: 16px;
  }

  .vertical-box.nocommercial .nocommercial-div .title-div {
    font: normal normal bold 15px/18px Lato;
    position: absolute;
    bottom: 12px;
  }

  .vertical-box.nocommercial .nocommercial-div {
    width: 35%;
    position: relative;
  }

  .custom-vertical-boxes-container {
    padding-bottom: 16px !important;
  }

  .vertical-box.fullcommercial .card-body {
    margin-left: 40px;
  }

  .vertical-box.two-commercial .card-header .fullname {
    padding-top: 12px !important;
  }

  .quotations-main .vertical-box.two-commercial,
  .quotations-main .vertical-box.three-commercial {
    display: flex;
    width: 100%;
  }
}

/***** quotations *****/
.quotations-main .vertical-box .card-header {
  padding-left: 0;
}

.quotations-main .vertical-box .card-header .initials {
  position: relative;
  left: 0;
  top: 0;
}

.quotations-main .vertical-box.full-commercial {
  height: 400px;
  position: relative;
}

.quotations-main .vertical-box .card-header .bu-top {
  display: inline;
}

.quotations-main .vertical-box .card-header .bu {
  display: none;
}

.quotations-main
  .commercial-col
  .show-request-container
  .vertical-box.three-commercial
  .commercial-div,
.quotations-main
  .commercial-col
  .show-request-container
  .vertical-box.two-commercial
  .commercial-div {
  /* display: flex; */
  height: 100%;
}

.quotations-main .commercial-col .vertical-box.three-commercial .commercial-div,
.quotations-main .commercial-col .vertical-box.two-commercial .commercial-div {
  display: flex;
  height: 100%;
}

.vertical-box .commercial-div .rounded-div {
  border: 6px solid;
  height: 200px;
  width: 200px;
  border-radius: 200px;
  margin: auto;
  text-align: center;
  line-height: 194px !important;
  font: normal normal bold 82px/101px Roboto;
  letter-spacing: 0px;
  background-color: #6f767a80;
}

.quotations-main .vertical-box .commercial-div .card-header {
  font: normal normal bold 23px/28px Roboto;
  letter-spacing: 0px;
}

.quotations-main .vertical-box .commercial-div .card-body {
  font: normal normal bold 20px/24px Roboto;
  letter-spacing: 0px;
  white-space: nowrap;
}

.quotations-main .vertical-box.one-commercial {
  display: flex;
  width: 100%;
}

.quotations-main .vertical-box.one-commercial .commercial-div {
  display: flex;
  /* width: 100%; */
}

.quotations-main
  .commercial-col.show-request-container
  .vertical-box.two-commercial,
.quotations-main
  .commercial-col.show-request-container
  .vertical-box.three-commercial {
  display: flex;
  width: 100%;
}

.quotations-main .vertical-box.two-commercial .btn-div,
.quotations-main .vertical-box.three-commercial .btn-div,
.quotations-main .vertical-box.one-commercial .btn-div {
  width: 20%;
  position: relative;
}

.quotations-main .vertical-box.two-commercial .btn-div button,
.quotations-main .vertical-box.one-commercial .btn-div button {
  position: absolute;
  top: 50%;
  bottom: 0;
  left: 0 !important;
  margin: 0;
  transform: translateY(-50%);
}

.quotations-main .vertical-box.three-commercial .btn-div button {
  position: absolute;
  top: 50% !important;
  bottom: 0 !important;
  left: 0 !important;
  margin: 0 !important;
  transform: translateY(-50%);
}

.quotations-main .vertical-box.two-commercial .card-header .bu-top {
  padding-bottom: 40px;
}

.quotations-main .vertical-box.two-commercial .initials,
.quotations-main .vertical-box.three-commercial .initials,
.quotations-main .vertical-box.one-commercial .initials {
  margin-top: 26px;
}

.quotations-main
  .show-request-container
  .vertical-box.two-commercial
  .button-request,
.quotations-main
  .show-request-container
  .vertical-box.three-commercial
  .button-request,
.quotations-main
  .show-request-container
  .vertical-box.one-commercial
  .button-request,
.quotations-main
  .show-request-container
  .vertical-box.fullcommercial
  .button-request {
  display: none;
}

.quotations-main .input-form-container .secondrow {
  margin-top: 0 !important;
}

.input-form-container .row.requestrow {
  margin-top: 0 !important;
}

.quotations-main .commercial-col .vertical-box.three-commercial .card-header,
.quotations-main .commercial-col .vertical-box.two-commercial .card-header {
  position: relative;
  text-align: center;
  height: 100%;
  font: normal normal bold 23px/28px Roboto;
  letter-spacing: 0px;
  width: 100%;
}

.quotations-main .commercial-col .vertical-box.one-commercial .card-header {
  position: relative;
  text-align: center;
  height: 100%;
  font: normal normal bold 23px/28px Roboto;
  letter-spacing: 0px;
  margin-left: 66px;
  margin-right: 66px;
  width: 250px;
}

.quotations-main
  .commercial-col.show-request-container
  .vertical-box.three-commercial
  .card-header,
.quotations-main
  .commercial-col.show-request-container
  .vertical-box.two-commercial
  .card-header {
  position: relative;
  text-align: center;
  height: 100%;
  font: normal normal bold 23px/28px Roboto;
  letter-spacing: 0px;
  margin-left: 66px;
  margin-right: 66px;
  width: 250px;
}

@media (max-width: 600px) {
  .quotations-main .vertical-box {
    border-radius: 20px;
  }

  .second-row .vertical-box.three-commercial,
  .second-row .vertical-box.two-commercial,
  .custom-vertical-boxes-container .vertical-box.three-commercial {
    height: 107px;
    position: relative;
    border: 4px;
  }

  .profile-main .vertical-box.full-commercial .commercial-div .rounded-div,
  .profile-main .vertical-box.two-commercial .commercial-div .rounded-div,
  .profile-main .vertical-box.three-commercial .commercial-div .rounded-div,
  .quotations-main .vertical-box .commercial-div .rounded-div {
    border: 4px solid;
    height: 80px;
    width: 80px;
    border-radius: 80px;
    margin: auto;
    text-align: center;
    line-height: 76px !important;
    font: normal normal bold 30px/35px Roboto;
    letter-spacing: 0px;
    background-color: #6f767a80;
  }

  .quotations-main .vertical-box .commercial-div .rounded-div {
    margin-top: 0;
  }

  .vertical-box.three-commercial .card-header,
  .vertical-box.two-commercial .card-header {
    padding-left: 110px;
    position: absolute;
    height: 100%;
    left: 0px;
    margin-left: 0px;
  }

  .quotations-main .vertical-box.three-commercial .card-header .bu-top,
  .quotations-main .vertical-box.two-commercial .card-header .bu-top {
    display: none;
  }

  .vertical-box.fullcommercial .card-header .bu-top,
  .vertical-box.three-commercial .card-header .bu,
  .vertical-box.two-commercial .card-header .bu {
    font: normal normal bold 15px/18px Roboto;
    display: block;
    text-align: left;
  }

  .quotations-main .vertical-box .card-header .fullname {
    font: normal normal bold 15px/18px Roboto;
    text-align: left;
  }

  .quotations-main .vertical-box.three-commercial .card-header .initials,
  .quotations-main .vertical-box.two-commercial .card-header .initials {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 12px;
  }

  .vertical-box.two-commercial .commercial-div .card-header,
  .vertical-box.three-commercial .commercial-div .card-header,
  .vertical-box.full-commercial .commercial-div .card-header,
  .vertical-box.full-commercial .commercial-div .card-body {
    font: normal normal bold 15px/18px Roboto;
    letter-spacing: 0px;
    width: auto;
  }

  .quotations-main .vertical-box.three-commercial .card-header {
    margin-right: 0px;
  }

  .quotations-main .vertical-box.two-commercial .btn-div,
  .quotations-main .vertical-box.three-commercial .btn-div {
    width: 140px;
    position: absolute;
    bottom: 34px;
    right: 6px;
  }

  .quotations-main .vertical-box.two-commercial .card-body {
    display: none;
  }

  .quotations-main .vertical-box.three-commercial .card-header,
  .quotations-main .vertical-box.two-commercial .card-header {
    margin-left: 0px;
  }

  /**** fullcommercial ****/

  .quotations-main .vertical-box.fullcommercial {
    border-width: 4px !important;
    height: 415px;
  }

  .quotations-main .vertical-box.fullcommercial .btn-div {
    height: 80px;
    position: relative;
  }

  .quotations-main .vertical-box.fullcommercial .btn-div button {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  .quotations-main .vertical-box.fullcommercial .commercial-div {
    display: block;
    height: auto;
  }

  .quotations-main .vertical-box.fullcommercial .commercial-div .card-header {
    height: auto;
    padding-top: 12px;
  }

  .quotations-main
    .vertical-box.fullcommercial
    .commercial-div
    .card-header
    .initials {
    position: relative;
    margin-top: 8px;
  }

  .quotations-main
    .vertical-box.fullcommercial
    .commercial-div
    .card-header
    .fullname,
  .quotations-main
    .vertical-box.fullcommercial
    .commercial-div
    .card-header
    .bu-top {
    text-align: center;
  }

  .quotations-main .vertical-box.fullcommercial .commercial-div .card-body {
    font: normal normal bold 15px/18px Roboto;
  }

  .quotations-main .vertical-box.fullcommercial .nocommercial-div {
    display: none;
  }

  .vertical-box.two-commercial .commercial-div,
  .vertical-box.three-commercial .commercial-div {
    width: 100%;
  }
}

/**** profile ****/

.profile-main .show-request-container .vertical-box {
  height: 470px;
}

.profile-main .vertical-box.full-commercial .card-body .inner-card-body {
  margin-left: 24px;
  margin-top: 20px;
  line-height: 36px;
}

.profile-main .show-request-container .vertical-box.full-commercial .card-body {
  display: inline;
}

.profile-main .show-request-container .btn-div {
  display: none;
}

.profile-main .show-request-container .input-form-container {
  display: block !important;
}

.profile-main .commercial-col.show-request-container {
  flex: unset;
  max-width: 100%;
  width: 100%;
}

.profile-main
  .show-request-container
  .vertical-box.full-commercial
  .button-request {
  display: none;
}

.profile-main .show-request-container .vertical-box.full-commercial {
  display: flex;
}

.profile-main
  .show-request-container
  .vertical-box.full-commercial
  .commercial-div {
  width: 350px;
}

.profile-main
  .show-request-container
  .vertical-box.full-commercial
  .card-header {
  padding-left: 0;
}

.profile-main
  .show-request-container
  .vertical-box.full-commercial
  .card-header {
  padding-left: 0;
}

.profile-main
  .show-request-container
  .vertical-box.full-commercial
  .card-header
  .bu {
  display: none;
}

.profile-main
  .show-request-container
  .vertical-box.full-commercial
  .card-header
  .bu-top {
  display: block;
}

.quotations-main .show-request-container .input-form-container button,
.profile-main .show-request-container .input-form-container button {
  bottom: unset !important;
  position: absolute !important;
  transform: none;
  right: 0px;
  left: unset !important;
  top: 16px !important;
}

.quotations-main
  .show-request-container
  .input-form-container
  .button-div
  button,
.profile-main .show-request-container .input-form-container .button-div button {
  bottom: 0px;
  position: relative !important;
  transform: none;
  left: 0;
  float: none;
}

.quotations-main .show-request-container .input-form-container .button-div,
.profile-main .show-request-container .input-form-container .button-div {
  text-align: center;
}

.quotations-main .show-request-container .input-form-container,
.profile-main .show-request-container .input-form-container {
  position: relative;
}

.quotations-main .show-request-container .input-form-container .email-sent,
.profile-main .show-request-container .input-form-container .email-sent {
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  left: 50%;
  width: 100%;
}

.commercial-div .button-back {
  display: none;
}

.profile-main .show-request-container .commercial-div .button-back {
  display: block;
  bottom: 0px;
  position: relative;
  left: 0px;
  transform: none;
  margin-top: 20px;
}

.profile-main .show-request-container.col {
  padding-top: 0;
}

@media (max-width: 600px) {
  .profile-main .vertical-box.three-commercial .commercial-div .rounded-div {
    display: block;
  }
  .profile-main .show-request-container.col {
    padding-top: 16px;
  }
  .profile-main .show-request-container .vertical-box.full-commercial {
    border-width: 4px !important;
    border-radius: 20px;
    display: block;
  }

  .profile-main .show-request-container .vertical-box {
    height: 730px;
  }

  .profile-main
    .show-request-container
    .vertical-box.full-commercial
    .commercial-div
    .card-header {
    padding-left: 110px !important;
  }

  .profile-main
    .show-request-container
    .vertical-box.full-commercial
    .commercial-div
    .card-header {
    /* margin-top: 12px; */
    padding-left: 110px !important;
    height: 100px;
  }

  .profile-main
    .show-request-container
    .vertical-box.full-commercial
    .commercial-div
    .card-header
    .initials {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
  }
  .profile-main
    .show-request-container
    .vertical-box.full-commercial
    .commercial-div
    .button-back-div {
    position: absolute;
    top: 29px;
    right: 16px;
  }

  .profile-main
    .show-request-container
    .vertical-box.full-commercial
    .input-form-container {
    height: 400px;
  }

  .profile-main
    .show-request-container
    .vertical-box.full-commercial
    .input-form-container
    .msg-container {
    margin-bottom: 100px;
  }

  .quotations-main .show-request-container .input-form-container button,
  .profile-main .show-request-container .input-form-container button {
    /* bottom: unset !important;
  position: absolute !important;
  transform: none;
  right: 0px;
  left: unset !important; */
    top: 80px !important;
  }

  /* .profile-main .show-request-container .userdata-container {
    display: none;
  } */
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import router from "@/router/index.js";
import inputForm from "./inputForm.vue";

export default {
  props: {
    item: Object,
    color: String,
    component_class: String,
    title: String,
    img_name: String,
    divisionId: String,
    division: "",
    isInQuotations: { default: false, type: Boolean },
    showTerm: {
      default: false,
      type: Boolean,
    },
    isProfile: {
      default: false,
      type: Boolean,
    },
  },

  components: {
    inputForm,
  },

  computed: {
    commercialRequestIsHidden: function () {
      return this.$store.getters.GET_selectedCommercial;
    },
  },

  watch: {
    commercialRequestIsHidden: {
      handler() {
        this.setDetails(!this.$store.getters.GET_selectedCommercial.show);
      },
    },
  },

  data() {
    return {
      isMobile: false,
      requestVisible: false,
      button_class: "generic-button vertical-align-right-20",
      role: "",
      roleTruncate: "",
      email: "",
      phone: "",
      mobile: "",
      truncate: true,
    };
  },

  created() {
    window.addEventListener("resize", this.myEventHandler);
    this.setIsMobile();
    this.setDetails(true);

    // console.log("item", this.item);
  },
  mounted() {
    this.$emit("created", true);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },

  methods: {
    getBtnName() {
      if (this.item.nome) return Trans.i18n.t("Misc.contact");
      else {
        if (!this.isMobile) {
          return Trans.i18n.t("Misc.request");
        } else {
          return Trans.i18n.t("Misc.request_mobile");
        }
      }
    },
    getFullName() {
      // console.log("nome", this.item.nome.length, "cognome", this.item.cognome.length, "limit", process.env.VUE_APP_MAX_COMPRESSION_TRUNCATE_VALUE);
      if (
        this.item.nome.length + this.item.cognome.length + 1 >
        process.env.VUE_APP_MAX_COMPRESSION_TRUNCATE_VALUE
      ) {
        if (
          this.item.nome[0].length + this.item.cognome.length + 2 >
          process.env.VUE_APP_MAX_COMPRESSION_TRUNCATE_VALUE
        ) {
          return (
            (this.item.nome[0] + ". " + this.item.cognome).substring(
              0,
              process.env.VUE_APP_MAX_COMPRESSION_TRUNCATE_VALUE
            ) + "..."
          );
        } else {
          return this.item.nome[0] + ". " + this.item.cognome;
        }
      } else return this.item.nome + " " + this.item.cognome;
    },
    getEmail() {
      this.email = this.$genericClass.TruncateString(
        this.item.email,
        this.truncate
      );
    },
    getRole() {
      this.role = this.$genericClass.TruncateString(
        this.item.ruolo,
        this.truncate
      );
    },
    getRoleTruncation() {
      this.roleTruncate = this.$genericClass.TruncateRoleString(
        this.item.ruolo,
        this.truncate
      );
    },
    getPhone() {
      this.phone = this.$genericClass.TruncateString(
        this.item.telefono,
        this.truncate
      );
    },
    getMobile() {
      this.mobile = this.$genericClass.TruncateString(
        this.item.cellulare,
        this.truncate
      );
    },
    setDetails(truncate) {
      this.truncate = truncate;
      this.getEmail();
      this.getRoleTruncation();
      this.getRole();
      this.getPhone();
      this.getMobile();
    },
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
    contact() {
      this.setDetails(false);
      // quotations
      if (!this.isProfile) {
        if (this.item.nome) {
          this.requestVisible = true;
          let arg = {
            commercialSelected: this.item,
            show: true,
            color: this.color,
          };
          this.$store.commit("SET_selectedCommercial", arg);
          this.$emit("contact", true);
        } else {
          router
            .push({ name: "division", params: { DivisionId: this.divisionId } })
            .catch((err) => {
              this.close();
            });
        }
      }
      // profile
      else {
        router
          .push({ name: "quotations", params: { DivisionId: this.divisionId } })
          .catch((err) => {
            this.close();
          });
      }
    },
    back() {
      let arg = {
        commercialSelected: this.item,
        show: false,
        color: this.color,
      };
      this.$store.commit("SET_selectedCommercial", arg);
    },
  },
};
</script>